import { Input } from "../../display/Input";
import { Event } from "../../events/Event";
import { GButton } from "../GButton";
import { ButtonMode, LayoutType, SelectionMode } from "../Const";
import { UIEvent } from "../UIEvent";
import { NodeFlags } from "../../Const";
export class Selection {
    constructor(owner) {
        this.scrollItemToViewOnClick = false;
        this.allowSelectByRightClick = true;
        this._mode = 0;
        this._lastIndex = 0;
        this._owner = owner;
        this._lastIndex = -1;
    }
    get mode() {
        return this._mode;
    }
    set mode(value) {
        this._mode = value;
    }
    get index() {
        return this._owner.children.findIndex(obj => (obj instanceof GButton) && obj.selected);
    }
    set index(value) {
        if (value >= 0 && value < this._owner.numChildren) {
            if (this._mode != SelectionMode.Single)
                this.clear();
            this.add(value);
        }
        else
            this.clear();
    }
    get controller() {
        return this._controller;
    }
    set controller(value) {
        if (this._controller)
            this._controller.release();
        this._controller = value;
        if (value) {
            value.validate();
            value.onChanged = this.selectChanged.bind(this);
            this.selectChanged();
        }
    }
    get(out) {
        if (!out)
            out = [];
        for (let i = 0, cnt = this._owner.children.length; i < cnt; i++) {
            let obj = this._owner.children[i];
            if ((obj instanceof GButton) && obj.selected)
                out.push(i);
        }
        return out;
    }
    add(index, scrollItToView) {
        var _a;
        if (this._mode == SelectionMode.Disabled)
            return;
        if (this._mode == SelectionMode.Single)
            this.clear();
        if (scrollItToView)
            (_a = this._owner.scroller) === null || _a === void 0 ? void 0 : _a.scrollTo(index);
        this._lastIndex = index;
        let obj;
        if (this._owner._getBit(NodeFlags.EDITING_NODE))
            obj = this._owner.children.filter(child => !child._extra.isTemplateNode)[index];
        else
            obj = this._owner.getChildAt(index);
        if ((obj instanceof GButton) && !obj.selected)
            obj.selected = true;
        this.syncController(index);
    }
    remove(index) {
        if (this._mode == SelectionMode.Disabled)
            return;
        let obj;
        if (this._owner._getBit(NodeFlags.EDITING_NODE))
            obj = this._owner.children.filter(child => !child._extra.isTemplateNode)[index];
        else
            obj = this._owner.getChildAt(index);
        if (obj instanceof GButton)
            obj.selected = false;
    }
    clear() {
        for (let obj of this._owner.children) {
            if ((obj instanceof GButton) && !obj._extra.isTemplateNode)
                obj.selected = false;
        }
    }
    clearExcept(g) {
        for (let obj of this._owner.children) {
            if ((obj instanceof GButton) && obj != g && !obj._extra.isTemplateNode)
                obj.selected = false;
        }
    }
    selectAll() {
        for (let obj of this._owner.children) {
            if ((obj instanceof GButton) && !obj.selected) {
                obj.selected = true;
            }
        }
    }
    selectReverse() {
        for (let obj of this._owner.children) {
            if (obj instanceof GButton) {
                obj.selected = !obj.selected;
            }
        }
    }
    enableFocusEvents(enabled) {
        if (this._triggerFocusEvents == enabled)
            return;
        this._triggerFocusEvents = enabled;
    }
    handleFocus(evt) {
        let eventType = evt.type == "focus_in" ? "list_focus_in" : "list_focus_out";
        for (let obj of this._owner.children) {
            if ((obj instanceof GButton) && obj.selected)
                obj.event(eventType);
        }
    }
    handleClick(item, evt) {
        let scroller = this._owner.scroller;
        if (scroller === null || scroller === void 0 ? void 0 : scroller.isDragged)
            return;
        if (evt.button == 2 && !this.allowSelectByRightClick)
            return;
        if (item.mode == ButtonMode.Common) {
            this._owner.event(UIEvent.ClickItem, [item, evt]);
            return;
        }
        let dontChangeLastIndex = false;
        let index = this._owner.getChildIndex(item);
        if (this._mode == SelectionMode.Disabled) {
        }
        else if (this._mode == SelectionMode.Single) {
            if (!item.selected) {
                this.clearExcept(item);
                item.selected = true;
                item.event(Event.CHANGED);
            }
        }
        else {
            if (evt.shiftKey) {
                if (!item.selected) {
                    if (this._lastIndex != -1) {
                        let min = Math.min(this._lastIndex, index);
                        let max = Math.max(this._lastIndex, index);
                        max = Math.min(max, this._owner.numChildren - 1);
                        for (let i = min; i <= max; i++) {
                            let obj = this._owner.getChildAt(i);
                            if (obj instanceof GButton) {
                                obj.selected = true;
                                if (obj == item)
                                    item.event(Event.CHANGED);
                            }
                        }
                        dontChangeLastIndex = true;
                    }
                    else {
                        item.selected = true;
                        item.event(Event.CHANGED);
                    }
                }
            }
            else if ((evt.ctrlKey || evt.metaKey) || this._mode == SelectionMode.MultipleBySingleClick) {
                item.selected = !item.selected;
                item.event(Event.CHANGED);
            }
            else {
                if (!item.selected) {
                    this.clearExcept(item);
                    item.selected = true;
                    item.event(Event.CHANGED);
                }
                else if (evt.button == 0)
                    this.clearExcept(item);
            }
        }
        if (!dontChangeLastIndex)
            this._lastIndex = index;
        if (scroller && this.scrollItemToViewOnClick)
            scroller.scrollTo(item, true);
        if (item.selected)
            this.syncController(index);
        if (evt.isDblClick && (evt.target instanceof Input))
            return;
        this._owner.event(UIEvent.ClickItem, [item, evt]);
    }
    enableArrowKeyNavigation(enabled, keySelectEvent) {
        if (enabled) {
            this._keyEvent = keySelectEvent != null ? keySelectEvent : UIEvent.ClickItem;
            this._owner.on(Event.KEY_DOWN, this, this._keydown);
        }
        else {
            this._owner.off(Event.KEY_DOWN, this, this._keydown);
        }
    }
    _keydown(evt) {
        if ((evt.target instanceof Input) || evt.ctrlKey || evt.metaKey || evt.altKey || evt.shiftKey)
            return;
        let index = -1;
        switch (evt.key) {
            case "ArrowLeft":
                index = this.handleArrowKey(7, evt);
                break;
            case "ArrowRight":
                index = this.handleArrowKey(3, evt);
                break;
            case "ArrowUp":
                index = this.handleArrowKey(1, evt);
                break;
            case "ArrowDown":
                index = this.handleArrowKey(5, evt);
                break;
        }
        if (index != -1)
            evt.stopPropagation();
    }
    handleArrowKey(dir, evt) {
        var _a;
        let curIndex = this.index;
        if (curIndex == -1) {
            if (this._owner.numChildren > 0) {
                this.clear();
                this.add(0, true);
                if (this._keyEvent)
                    this._owner.event(this._keyEvent, [this._owner.getChildAt(0), evt]);
                return 0;
            }
            else
                return -1;
        }
        let index = curIndex;
        let layout = (_a = this._owner.layout) === null || _a === void 0 ? void 0 : _a.type;
        if (layout == null)
            layout = LayoutType.FlowX;
        switch (dir) {
            case 1:
                if (layout == LayoutType.SingleColumn || layout == LayoutType.FlowY) {
                    index--;
                }
                else if (layout == LayoutType.FlowX) {
                    let current = this._owner.getChildAt(index);
                    let k = 0;
                    let i;
                    for (i = index - 1; i >= 0; i--) {
                        let obj = this._owner.getChildAt(i);
                        if (obj.y != current.y) {
                            current = obj;
                            break;
                        }
                        k++;
                    }
                    for (; i >= 0; i--) {
                        let obj = this._owner.getChildAt(i);
                        if (obj.y != current.y) {
                            index = i + k + 1;
                            break;
                        }
                    }
                }
                break;
            case 3:
                if (layout == LayoutType.SingleRow || layout == LayoutType.FlowX) {
                    index++;
                }
                else if (layout == LayoutType.FlowY) {
                    let current = this._owner.getChildAt(index);
                    let k = 0;
                    let i;
                    let cnt = this._owner.numChildren;
                    for (i = index + 1; i < cnt; i++) {
                        let obj = this._owner.getChildAt(i);
                        if (obj.x != current.x) {
                            current = obj;
                            break;
                        }
                        k++;
                    }
                    for (; i < cnt; i++) {
                        let obj = this._owner.getChildAt(i);
                        if (obj.x != current.x) {
                            index = i - k - 1;
                            break;
                        }
                    }
                }
                break;
            case 5:
                if (layout == LayoutType.SingleColumn || layout == LayoutType.FlowY) {
                    index++;
                }
                else if (layout == LayoutType.FlowX) {
                    let current = this._owner.getChildAt(index);
                    let k = 0;
                    let i;
                    let cnt = this._owner.numChildren;
                    for (i = index + 1; i < cnt; i++) {
                        let obj = this._owner.getChildAt(i);
                        if (obj.y != current.y) {
                            current = obj;
                            break;
                        }
                        k++;
                    }
                    for (; i < cnt; i++) {
                        let obj = this._owner.getChildAt(i);
                        if (obj.y != current.y) {
                            index = i - k - 1;
                            break;
                        }
                    }
                }
                break;
            case 7:
                if (layout == LayoutType.SingleRow || layout == LayoutType.FlowX) {
                    index--;
                }
                else if (layout == LayoutType.FlowY) {
                    let current = this._owner.getChildAt(index);
                    let k = 0;
                    let i;
                    for (i = index - 1; i >= 0; i--) {
                        let obj = this._owner.getChildAt(i);
                        if (obj.x != current.x) {
                            current = obj;
                            break;
                        }
                        k++;
                    }
                    for (; i >= 0; i--) {
                        let obj = this._owner.getChildAt(i);
                        if (obj.x != current.x) {
                            index = i + k + 1;
                            break;
                        }
                    }
                }
                break;
        }
        if (index != curIndex && index >= 0 && index < this._owner.numChildren) {
            this.clear();
            this.add(index, true);
            if (this._keyEvent) {
                this._owner.event(this._keyEvent, [this._owner.getChildAt(index), evt]);
            }
            return index;
        }
        else
            return -1;
    }
    selectChanged() {
        if (this._controller)
            this.index = this._controller.selectedIndex;
    }
    syncController(index) {
        let cc = this._controller;
        if (cc) {
            this._controller = null;
            cc.selectedIndex = index;
            this._controller = cc;
        }
    }
    _refresh() {
        if (this._mode === SelectionMode.None)
            return;
        if (this._controller)
            this.index = this._controller.selectedIndex;
        else
            this.index = this._lastIndex;
    }
    destroy() {
        if (this._controller)
            this._controller.release();
    }
}
